import { createContext, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

const ContentContext = createContext({ data: null, isLoading: true });

export function ContentProvider({ children }) {
  const q = useQuery({ queryKey: ["content"], queryFn: async () => (await api.get("/content")).data, staleTime: 5 * 60_000 });
  return <ContentContext.Provider value={{ data: q.data, isLoading: q.isLoading, error: q.error, refetch: q.refetch }}>{children}</ContentContext.Provider>;
}

export const useContent = () => useContext(ContentContext);

export function minPriceForBuilding(roomTypes, buildingId) {
  const list = (roomTypes || []).filter((r) => r.building === buildingId);
  if (!list.length) return null;
  return Math.min(...list.map((r) => Math.min(r.prices.weekday.p1, r.prices.weekend.p1)));
}

export function minPrice(rt) {
  if (!rt) return null;
  return Math.min(rt.prices.weekday.p1, rt.prices.weekend.p1);
}

/** Upcoming + recurring happenings (recurring = no date) sorted: dated first by date, then recurring by sort */
export function upcomingHappenings(list, todayIso) {
  const today = todayIso || new Date().toISOString().slice(0, 10);
  const items = (list || []).filter((h) => h.active !== false && (!h.date || h.date >= today));
  return items.sort((a, b) => {
    if (a.date && b.date) return a.date < b.date ? -1 : 1;
    if (a.date) return -1;
    if (b.date) return 1;
    return (a.sort || 0) - (b.sort || 0);
  });
}
